<script>
export default {
  methods: {
    action(e, action, metadata) {
      this.closeModal({
        action,
        metadata,
        e,
      });
    },
  },
};
</script>
